export default async function ({ app, redirect }) {
  const cookies = app.$cookies;
  const token = cookies.get('token')

  if (token) {
    return redirect('/panel')
  }
}
